import { useEffect } from 'react';
import { GetWeavePopNotificationByType } from '@frontend/types';
import { useNotificationPreferences } from './store';

const NOTIFICATION_TYPE = 'ai-receptionist-state';
const SUPPRESS_RULE_ID = 'ai-receptionist-state-thread-focus-suppress';

export const useAiReceptionistStateSuppress = () => {
  const { addSuppressRule } = useNotificationPreferences(['addSuppressRule']);

  useEffect(() => {
    const unsubscribeSuppressRule = addSuppressRule({
      id: SUPPRESS_RULE_ID,
      for: NOTIFICATION_TYPE,
      condition: (notification, context) => {
        const aiNotification = notification as GetWeavePopNotificationByType<'ai-receptionist-state'>;
        const locationId = aiNotification.payload.threadAiActivity?.locationId;
        const threadId = aiNotification.payload.threadAiActivity?.threadId;

        if (!locationId || !threadId) {
          return false;
        }

        const isAtThread = context.pathname?.startsWith(`/messages/inbox/${locationId}/${threadId}`);
        return !!isAtThread && document.hasFocus();
      },
    });

    return () => {
      unsubscribeSuppressRule();
    };
  }, [addSuppressRule]);
};
